import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { md } = breakpoints.BreakpointNames;

export const pollBodyCss = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: "32px 32px 16px",

  [mediaQuery.upTo(md)]: {
    padding: "16px 20px 0",
  },
};

export const pollQuestionCss = (isInteractive) => {
  return [
    {
      // RadionButton from Angelou has a 2px (hidden) border and 4px padding
      // so the bottom margin here should be 6px smaller than designed
      margin: isInteractive ? "0 0 18px" : "0 0 24px",
      textAlign: "center",
    },
    typographyStyles.heading3,
  ];
};

export const pollOptionsCss = {
  display: "flex",
  padding: "0 0 32px",
};
